module.exports = __webpack_public_path__ + "assets/arrow_down-a62f94.svg";